"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var css = _interopRequireWildcard(require("./OptionChain.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const OptionChainScrollShadow = ({
  activeLeft = false,
  activeRight = false
}) => (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)("div", {
  css: css.scrollShadow,
  cssProps: {
    active: activeLeft,
    direction: 'left'
  }
}), (0, _pragma.createFelaElement)("div", {
  css: css.scrollShadow,
  cssProps: {
    active: activeRight,
    direction: 'right'
  }
}));

OptionChainScrollShadow.displayName = 'OptionChainScrollShadow';
var _default = OptionChainScrollShadow;
exports.default = _default;
//# sourceMappingURL=OptionChainScrollShadow.js.map